import columnTypes from '../columnTypes.js';
import types from '../types.js';

const cdTables = [
  {
    key: 'cd-filers',
    name: 'CD Filers',
    [columnTypes.default.key]: [
      {
        source: 'text',
        rename: 'Filer Name',
        type: types.text,
      },
      {
        source: 'FilerType',
        rename: 'Filer Type',
        type: types.text,
      },
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'LastScannedDate',
        rename: 'Last Scanned Date',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [{ source: 'id', rename: 'id' }],
  },
];

export default [...cdTables];
